import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import GruppiMerceologiciService from 'services/GruppiMerceologiciService';

export const initialState = {
    loadingGruppi: false,
    loadedGruppi: false,
    gruppi: [],
    errorGruppi: false,
};

export const loadGruppi = createAsyncThunk('gruppi-merceologici/load', async (companyDocumentId, { rejectWithValue }) => {
    try {
        const response = await GruppiMerceologiciService.getAll(companyDocumentId);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || err.message);
    }
});

export const createGruppo = createAsyncThunk('gruppi-merceologici/create', async (data, { rejectWithValue }) => {
    try {
        const response = await GruppiMerceologiciService.create(data);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || err.message);
    }
});

export const updateGruppo = createAsyncThunk('gruppi-merceologici/update', async ({ documentId, data }, { rejectWithValue }) => {
    try {
        const response = await GruppiMerceologiciService.update(documentId, data);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || err.message);
    }
});

const gruppiMerceologiciSlice = createSlice({
    name: 'gruppiMerceologici',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadGruppi.pending, (state) => {
                state.loadingGruppi = true;
                state.errorGruppi = false;
            })
            .addCase(loadGruppi.fulfilled, (state, action) => {
                state.loadingGruppi = false;
                state.loadedGruppi = true;
                state.gruppi = action.payload || [];
            })
            .addCase(loadGruppi.rejected, (state) => {
                state.loadingGruppi = false;
                state.loadedGruppi = true;
                state.errorGruppi = true;
                message.error('Errore nel caricamento dei gruppi merceologici');
            })
            .addCase(createGruppo.fulfilled, (state, action) => {
                state.gruppi = [...state.gruppi, action.payload];
                message.success('Gruppo merceologico creato con successo');
            })
            .addCase(createGruppo.rejected, () => {
                message.error('Errore nella creazione del gruppo merceologico');
            })
            .addCase(updateGruppo.fulfilled, (state, action) => {
                const idx = state.gruppi.findIndex((g) => g.documentId === action.payload.documentId);
                if (idx !== -1) {
                    state.gruppi[idx] = action.payload;
                }
                message.success('Gruppo merceologico aggiornato con successo');
            })
            .addCase(updateGruppo.rejected, () => {
                message.error("Errore nell'aggiornamento del gruppo merceologico");
            });
    },
});

export default gruppiMerceologiciSlice.reducer;
